import React, { PropsWithChildren } from "react";
import BookviewSearchbar from "./bookview-search-bar";
import BookviewSearchPanel from "./bookview-search-panel";

const BASE_CLASS_NAME = "c-mobile-bookview-search-panel";

interface MobileBookviewSearchPanelProps extends PropsWithChildren {
    isInLegacyPublicationView?: boolean;
}

const MobileBookviewSearchPanel: React.FC<MobileBookviewSearchPanelProps> = (
    props
) => {
    return (
        <>
            <div className={BASE_CLASS_NAME}>
                <BookviewSearchbar
                    isLegacyPublicationView={props.isInLegacyPublicationView}
                />
                <BookviewSearchPanel
                    isInLegacyPublicationView={props.isInLegacyPublicationView}
                />
                {props.children}
            </div>
        </>
    );
};

export default MobileBookviewSearchPanel;
